const preType = 'USERS_';

export const UsersTypes = {
  SET_USERS_LIST: `${preType}SET_USERS_LIST`,
  GET_EXTENDED_USERS: `${preType}GET_EXTENDED_USERS`,
  SWITCH_FILTER_MODAL: `${preType}SWITCH_FILTER_MODAL`,
  SET_FILTER_ITEMS: `${preType}SET_FILTER_ITEMS`,
  RESET_FILTER_ITEMS: `${preType}RESET_FILTER_ITEMS`,
  GET_USER_DETAILS: `${preType}GET_USER_DETAILS`,
  SET_USER_CONTACT: `${preType}SET_USER_CONTACT`,
  SET_USER_SERVICE_ID: `${preType}SET_USER_SERVICE_ID`,
  SET_USER_FIRST_APPOINTMENT: `${preType}SET_USER_FIRST_APPOINTMENT`,
  SET_USER_ITEM_LOADING: `${preType}SET_USER_ITEM_LOADING`,
  SET_USER_ITEM_EXPANDED: `${preType}SET_USER_ITEM_EXPANDED`,
  DELETE_FILTER_TAG: `${preType}DELETE_FILTER_TAG`,
  SET_USER_SEARCH_LIST: `${preType}SET_USER_SEARCH_LIST`,
  GET_USER_SEARCH_LIST: `${preType}GET_USER_SEARCH_LIST`,
  SET_SEARCH_LOADING: `${preType}SET_SEARCH_LOADING`,
};

const setUsersList = (data: { usersList: Array<object>, lastPage?: number, currentPage?: number }) => ({ type: UsersTypes.SET_USERS_LIST, data: data });
const getExtendedUsers = () => ({ type: UsersTypes.GET_EXTENDED_USERS });
const switchFilterModal = (data: { filterModal: boolean }) => ({ type: UsersTypes.SWITCH_FILTER_MODAL, data: data });
const setFilterItems = (data: { key: string | undefined, id: string | undefined, value?: string | undefined }) => ({ type: UsersTypes.SET_FILTER_ITEMS, data: data });
const resetFilterItems = () => ({ type: UsersTypes.RESET_FILTER_ITEMS });
const getUserDetails = (data: { selectedUserSlug: string }) => ({ type: UsersTypes.GET_USER_DETAILS, data: data });
const setUserItemExpanded = (data: { expanded: string | boolean }) => ({ type: UsersTypes.SET_USER_ITEM_EXPANDED, data: data });
const deleteFilterTag = (data: { key: string }) => ({ type: UsersTypes.DELETE_FILTER_TAG, data: data });
const getUsersSearchList = (data: { searchValue: string }) => ({ type: UsersTypes.GET_USER_SEARCH_LIST, data: data });
const setSearchLoading = (data: { searchLoading: boolean }) => ({ type: UsersTypes.SET_SEARCH_LOADING, data });

export const UsersActions = {
  setUsersList: setUsersList,
  getExtendedUsers: getExtendedUsers,
  switchFilterModal: switchFilterModal,
  setFilterItems: setFilterItems,
  resetFilterItems: resetFilterItems,
  getUserDetails: getUserDetails,
  setUserItemExpanded: setUserItemExpanded,
  deleteFilterTag: deleteFilterTag,
  getUsersSearchList: getUsersSearchList,
  setSearchLoading: setSearchLoading,
};
